import { useQuery, useMutation, useQueryClient } from 'react-query';
import axios from 'axios';

const apiUrl = process.env.REACT_APP_BASIX_API || '';

// item 1329 (Chad: "add a verification they sent and show a failure to send nag") — the
// delivery record for every subscription invoice email. Since item 1326 Basix is the ONLY
// sender of these, so a failed send is a customer with no invoice and no backstop. This is
// how the app answers "did the 1st actually go out?" instead of inferring it from silence.
export interface InvoiceEmailRow {
  id: string;
  invoiceNumber?: string | null;
  customerName?: string | null;
  subscriptionName?: string | null;
  recipient: string;
  amount?: number | null;
  /** 0 = pending (being retried), 1 = sent, 2 = abandoned — out of attempts. */
  status: number;
  attempts: number;
  lastError?: string | null;
  createdDate: string;
  sentDate?: string | null;
  lastAttemptDate?: string | null;
}

export interface InvoiceEmailDelivery {
  abandoned: number;
  pending: number;
  sent: number;
  rows: InvoiceEmailRow[];
}

export const EMAIL_PENDING = 0;
export const EMAIL_SENT = 1;
export const EMAIL_ABANDONED = 2;

export const useInvoiceEmailDelivery = (enabled = true) => useQuery(
  'invoiceEmailDelivery',
  async (): Promise<InvoiceEmailDelivery> => {
    const { data } = await axios.get(`${apiUrl}payment/invoice-email-delivery`);
    return data;
  },
  // a burst of 16 invoices lands on the 1st; a 60s refetch means the nag appears while
  // someone is still looking at the screen rather than on their next visit
  {
    enabled, staleTime: 30_000, refetchInterval: 60_000, retry: false,
  },
);

export const useRetryInvoiceEmail = () => {
  const qc = useQueryClient();
  return useMutation(
    async (id: string) => {
      const { data } = await axios.post(`${apiUrl}payment/invoice-email-delivery/${id}/retry`);
      return data;
    },
    { onSuccess: () => { qc.invalidateQueries('invoiceEmailDelivery'); } },
  );
};

export default useInvoiceEmailDelivery;
